import { useEffect } from "react";

const SITE_URL = "https://iprsinf.com.br";

export default function PageHead({ title, description, path, jsonLd }) {
  useEffect(() => {
    document.title = title;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "IPRS Soluções em TI");
    setMeta("property", "og:locale", "pt_BR");
    setMeta("property", "og:url", SITE_URL + path);
    setMeta("property", "og:image", SITE_URL + "/og-image-iprs.jpg");
    setMeta("property", "og:image:alt", "Logo da IPRS Soluções em TI");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", SITE_URL + "/og-image-iprs.jpg");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL + path;

    let ld = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.id = "page-jsonld";
        ld.type = "application/ld+json";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, jsonLd]);

  return null;
}
